import UsersDropdown from 'components/UsersDropdown';
import React, { useState } from 'react';
import { USER_ROLES } from 'utils';
import styles from './index.module.scss';
import ActionButton from 'components/ActionButton';

const ListViewModal = props => {
  const {
    toggleModal,
    title = '',
    list = [],
    renderItem = () => {}
  } = props;

  return (
    <form onSubmit={e => e.preventDefault()} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['modal-title']}>{title}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {list?.map((item, i) => {
            return renderItem(item, i)
          })}
        </div>
        <div className={styles['modal-footer']}>
          <ActionButton customClass={styles['close-button']} text='Close' onClick={toggleModal} isLoading={false} active={true} />
        </div>
      </div>
    </form>
  );
};

export default ListViewModal;